import { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, Link, useRouteLoaderData, Form, useNavigate, useLocation  } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { initTestsThunk, getTestsActions } from '../../store/tests';

import { getLabConfig } from '../../utils/api';
import ThemeContext from '../../store/ThemeContext';	
import LabIDContext from '../../store/LabIDContext';
import MenuContext from '../../store/MenuContext';
import HeaderClasses from './AppHeader.module.css';

const HamburgerMenu = ({onMenuSelect}) => {
	const navigate = useNavigate();
	const location=useLocation();
	
	const labid = useContext(LabIDContext);	
	
	const cartState = useSelector(state => state.cart);
	const [portalTitle, setPortalTitle] = useState([]);
	const token = useRouteLoaderData('root');
	const labtestid = sessionStorage.getItem("Labtestid");
	const [PPURL, setPPURL] = useState([]);
	const dispatch = useDispatch();
		
	useEffect(() => {
        async function fetchPortalTitle() {
            const portalTitle = await getLabConfig('DTCLABEL');
            setPortalTitle(portalTitle);
			const PPURL = await getLabConfig("PPWEBSERVER");
			setPPURL(PPURL);
			document.title = portalTitle;
        }
        fetchPortalTitle();
    }, []);
	const colorTheme = useContext(ThemeContext);
	const resourceurl=colorTheme['resources-url'];
	const helpurl=colorTheme['help-url'];
	const handleMenu = () =>{

		onMenuSelect("done");
	}
	const historyURL = PPURL +"RPP/" + labid + "/patientportal/" + labid + "/history?token=" + token + "&labtestid=" + labtestid;
    //const historyURL = "localhost:3000/patientportal/" + labid + "/history?token=" + token + "&labtestid=" + labtestid;
    const loginLink = <Link to='Login' className={HeaderClasses.navItemLogin} title="Login">
		<img
			src={`/images/HamburgerIcons/Account Login.png`}
			style={{
			  width: '48px',
			  height: 'auto',
			  paddingTop: '5px',
			  paddingRight: '10px',
			  backgroundColor: 'transparent', 
			  mixBlendMode: 'multiply'        
			}}
			/>Account Login
				</Link>;

	const handleLogout = () => {
		  sessionStorage.clear();
	  window.location.href = "/Login";
	};
	const logoutLink = (
	  <button onClick={handleLogout} className={HeaderClasses.navItemLogout} title="Logout" ><img src={`/images/HamburgerIcons/Logout.png`} style={{
                     width: '48px',
                     height: 'auto',
                     paddingTop: '5px',
                     paddingRight: '10px',
                     backgroundColor: 'transparent', // won't help if image itself has white baked in
                     mixBlendMode: 'multiply'        // can help blend with background
                   }} />
		Logout
	  </button>
	);
	const isActive = location.pathname === 'availableTests';
	const shopAllHandler = async (event) => {
		sessionStorage.setItem("searchTerm", '');
		dispatch(getTestsActions().setSearch(''));
		dispatch(getTestsActions().clearCategories());
		dispatch(initTestsThunk(sessionStorage.getItem("topcatn"),sessionStorage.getItem("topcatn"),''));
		navigate(`availableTests`);	
	};

    return (
	<>
		<nav className={HeaderClasses.hamburgerNav} onClick={handleMenu}>
			<button
			  className={HeaderClasses.closeButton}
			  title="Close Menu"
			  onClick={handleMenu}
			>
			  ×
			</button>
			{loginLink}
			<NavLink to='' className={HeaderClasses.navItem} title="Home" onClick={() => dispatch(getTestsActions().setSearch(''))}>
				<img src={`/images/HamburgerIcons/Home.png`} style={{
					  width: '48px',
					  height: 'auto',
					  paddingTop: '5px',
					  paddingRight: '10px',
					  backgroundColor: 'transparent', 
					  mixBlendMode: 'multiply'       
					}} /> Home
			</NavLink>
			{token &&<NavLink to='orderHistory' className={HeaderClasses.navItem} title="Order History">
				<img src={`/images/HamburgerIcons/My Results.png`} style={{
					  width: '48px',
					  height: 'auto',
					  paddingTop: '5px',
					  paddingRight: '10px',
					  backgroundColor: 'transparent', // won't help if image itself has white baked in
					  mixBlendMode: 'multiply'        // can help blend with background
					}} />  Order History
			</NavLink>}
			{token &&<a href= {historyURL} className={HeaderClasses.navItem} title="Results" target="_RPP">
				<img src={`/images/HamburgerIcons/My Results.png`} style={{
					  width: '48px',
					  height: 'auto',
					  paddingTop: '5px',
					  paddingRight: '10px',
					  backgroundColor: 'transparent', // won't help if image itself has white baked in
					  mixBlendMode: 'multiply'        // can help blend with background
					}} /> My Results
			</a>}
			<button onClick={shopAllHandler} className={HeaderClasses.navItem}>
				<img src={`/images/HamburgerIcons/Shop for Tests.png`} style={{
					  width: '48px',
					  height: 'auto',
					  paddingTop: '5px',
					  paddingRight: '10px',
					  backgroundColor: 'transparent', // won't help if image itself has white baked in
					  mixBlendMode: 'multiply'        // can help blend with background
					}} /> Shop for Tests					
			</button>
			{token &&<NavLink to='userProfileEdit' className={HeaderClasses.navItem} title="Edit User Profile">
				<img src={`/images/HamburgerIcons/My Profile.png`} style={{
					  width: '48px',
					  height: 'auto',
					  paddingTop: '5px',
					  paddingRight: '10px',
					  backgroundColor: 'transparent', // won't help if image itself has white baked in
					  mixBlendMode: 'multiply'        // can help blend with background
					}} />My Profile
			</NavLink>}
			
			<a href={resourceurl} className={HeaderClasses.navItem} title="Resources" target="_blank"  rel="noopener noreferrer">
				<img src={`/images/HamburgerIcons/Resources.png`} style={{
					  width: '48px',
					  height: 'auto',
					  paddingTop: '5px',
					  paddingRight: '10px',
					  backgroundColor: 'transparent', // won't help if image itself has white baked in
					  mixBlendMode: 'multiply'        // can help blend with background
					}} /> Resources
			</a>
			<a href={helpurl} className={HeaderClasses.navItem} title="Help" target="_blank"  rel="noopener noreferrer">
				<img src={`/images/HamburgerIcons/Help.png`} style={{
					  width: '48px',
					  height: 'auto',
					  paddingTop: '5px',
					  paddingRight: '10px',
					  backgroundColor: 'transparent', // won't help if image itself has white baked in
					  mixBlendMode: 'multiply'        // can help blend with background
					}} /> Help
			</a>
			{logoutLink}
			
		</nav>

	</>
    );
};

export default HamburgerMenu;